/**
 * Strict standard email validation.
 * Allowed characters: letters, numbers, @, ., underscore, and hyphen.
 * Blocks other special characters (e.g. %, +, #, !).
 */

export const STANDARD_EMAIL_PATTERN = /^[A-Za-z0-9](?:[A-Za-z0-9._-]*[A-Za-z0-9])?@[A-Za-z0-9](?:[A-Za-z0-9.-]*[A-Za-z0-9])?\.[A-Za-z]{2,}$/;

const INVALID_EMAIL_CHARS_PATTERN = /[^A-Za-z0-9@._-]/;

export function sanitizeEmailInput(value) {
  return String(value || '').replace(/\s/g, '').replace(INVALID_EMAIL_CHARS_PATTERN, '');
}

export function getEmailValidationError(value, { required = true } = {}) {
  const emailValue = String(value || '').trim();

  if (!emailValue) {
    return required ? 'Email is required' : null;
  }

  if (/\s/.test(value)) {
    return 'Email cannot contain spaces';
  }

  if (INVALID_EMAIL_CHARS_PATTERN.test(emailValue)) {
    return 'Email contains invalid characters. Only letters, numbers, @, ., _, and - are allowed.';
  }

  if (!STANDARD_EMAIL_PATTERN.test(emailValue)) {
    return 'Invalid email format. Use a valid domain extension (e.g., .com, .org, .net).';
  }

  return null;
}

export function isValidEmail(value) {
  return getEmailValidationError(value, { required: false }) === null && String(value || '').trim() !== '';
}

/** Validate comma-separated recipient lists (To / CC / BCC). */
export function getEmailListValidationError(value, { required = false } = {}) {
  const trimmed = String(value || '').trim();
  if (!trimmed) {
    return required ? 'Email address is required' : null;
  }

  const emails = trimmed.split(',').map((email) => email.trim()).filter(Boolean);
  for (const email of emails) {
    const err = getEmailValidationError(email, { required: true });
    if (err) return err;
  }

  return null;
}

export function validateRequiredEmail(value) {
  return getEmailValidationError(value, { required: true });
}
